<template lang="pug">
  div
    CompanyEdit(:company="companyItem")
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'CompanyPage',
  components: {
    CompanyEdit: () => import('../../views/Company/CompanyEdit')
  },
  watch: {
    userRole: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$store.dispatch('GET_COMPANY_ITEM', this.userCompany.companyId)
        }
      }
    }
  },
  computed: {
    ...mapState({
      userCompany: state => state.userCompany,
      companyItem: state => state.company.companyItem,
      userRole: state => state.userInfo.role
    })
  }
}
</script>
